/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:404bd2d5-3d65-4cd1-bc2f-3eee6caaf377",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_4XUA6e3OD",
    "aws_user_pools_web_client_id": "7tq3088ihjivmiptl50bu90ri3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://f4bh3xbhxzcmnn2qltqk62d3xe.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-74axnhgponh4pljc3wj6shubyu",
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Fingerprint-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "Tag-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "Authentication-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "UserTag-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "website53c4c90c07134cfea499bb56eeb88697230454-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
